import { getClient } from '@zg-rentals/ts-client-http-client';

export const client = getClient().extend({
  prefixUrl: typeof window === 'undefined' ? process.env.PREFIX_URL : process.env.NEXT_PUBLIC_PREFIX_URL,
});
